module.exports = __webpack_public_path__ + "static/media/logo-light.76bf5aff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-light.svg
// module id = 210
// module chunks = 8